<template>
  <div>
    <v-autocomplete
      v-model="model"
      :items="items"
      :loading="isLoading"
      :search-input.sync="search"
      :return-object="false"
      :prepend-inner-icon="getIcon"
      :error-messages="errorMessages"
      :rules="multiple ? codeRulesMultiple : [...codeRules, ...rules]"
      @keydown.enter="$emit('addCustomer')"
      @blur="setSelection"
      required
      hide-no-data
      hide-selected
      item-text="full_code"
      item-value="full_code"
      class="capitalised-input"
      label="Код"
      placeholder="код участника"
      hint="Пример кода: АСЕ240191АМЕМ"
      style="min-width:190px">
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title style="text-overflow: ellipsis;">
            {{ item.full_code }}
            <template v-if="item.customerGroups && item.customerGroups.length>0">
              <v-chip
                v-for="group in item.customerGroups"
                :key="`${item.full_code}-${group.name}-search`"
                :color="groupColors[group.name]"
                class="ma-2"
                small>
                {{ group.name }}
              </v-chip>
            </template>
          </v-list-item-title>
        </v-list-item-content>
      </template>
      <template v-slot:append>
        <template v-if="findGroup(model).length>0">
          <v-chip
            v-for="group in findGroup(model)"
            :key="`${model}-${group}-val`"
            :color="groupColors[group]"
            class="ma-2"
            small>
            {{ group }}
          </v-chip>
        </template>
        <button @click="clearInput"
                type="button"
                aria-label="clear icon"
                class="v-icon notranslate v-icon--link mdi mdi-close theme--light error--text" />
        <!--        <v-checkbox v-if="oldValue"-->
        <!--                    v-model="isUpdate"-->
        <!--                    :value="isUpdate" />-->
      </template>
      <template v-slot:append-outer>
        <v-btn @click="addCustomer()"
               class="ml-auto flex-grow-0"
               dense
               small
               color="primary">
          <v-icon>mdi-account-multiple-plus</v-icon>
        </v-btn>
        <!--        </v-col>-->
      </template>
    </v-autocomplete>
    <template v-if="oldValue">
      <v-alert
        :icon="false"
        border="bottom"
        colored-border
        type="warning"
        dense>
        <v-row align="center">
          <v-col class="grow">
            Возможно код существует в старом формате <b>{{ oldValue }}</b>.
          </v-col>
          <v-col class="shrink">
            <v-checkbox v-if="oldValue"
                        v-model="isUpdate"
                        @change="updateCheckbox"
                        label="Переименовать" />
          </v-col>
        </v-row>
      </v-alert>
    </template>
  </div>
</template>

<script>
import {authHeader} from '../../_helpers'
import axios from 'axios'
import {API_URL} from '../../_services'

export default {
  name: "CustomersComboBox",
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rules: {
      type: [String, Array],
      default: () => []
    },
    selectedVal: {
      type: [String, Array],
      default: null
    }
  },
  data () {
    return {
      isLoading: false,
      search: this.selectedVal,
      entries: [this.selectedVal === null || this.selectedVal === '' ? {header: 'Начните ввод для поиска'} : this.selectedVal],
      groupColors: {'СР': 'pink', 'ЛУН': 'green', 'МСМ': 'blue'},
      fullEntries: [],
      model: this.selectedVal,

      errorMessages: '',
      oldValue: null,
      isUpdate: false,
      codeRules: [
        /* eslint-disable */
        v => !!v || 'Поле обязательно',
        v => !!v && !(/[^а-я0-9.,!?'"\s]/i.test(v)) || 'Значение должно быть на русском языке',

        v => !!v && !(/^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/.test(v.substring(0, 3))) && !(/\d/.test(v.substring(0, 3))) && v.length >= 3 || 'Первые три значения кода должны быть буквами',
        v => !!v && this.isValidDate(v.substring(3, 9)) && v.length >= 8 || 'Неверный формат даты рождения',
        v => !!v && !(/^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/.test(v.substring(9, 12))) && !(/\d/.test(v.substring(9, 12))) && v.length >= 11 || 'Последние три значения кода должны быть буквами',
        v => !!v && ['М', 'Ж', 'Т'].includes(v.toUpperCase().substring(12, 13)) && isNaN(v.substring(12, 13)) && v.length >= 12 ||
            'Последнее значение должно быть одним из М, Ж или Т',
        v => !!v && v && v.length === 13 || 'Код состоит из тринадцати символов'

      ],
      codeRulesMultiple: [
        v => v && v.some(cv => !!cv && !(/[^а-я0-9.,!?'"\s]/i.test(v))) || 'Значение должно быть на русском языке',
        v => v && v.some(cv => !!cv && !(/^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/.test(cv.substring(0, 3))) && !(/\d/.test(cv.substring(0, 3))) && cv.length >= 3) || 'Первые три значения кода должны быть буквами',
        v => v && v.some(cv => !!cv && this.isValidDate(cv.substring(3, 9)) && cv.length >= 8) || 'Неверный формат даты рождения',
        v => v && v.some(cv => !!cv && !(/^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/.test(cv.substring(9, 12))) && !(/\d/.test(cv.substring(9, 12))) && cv.length >= 11) || 'Последние три значения кода должны быть буквами',
        v => v && v.some(cv => !!cv && ['М', 'Ж', 'Т'].includes(cv.toUpperCase().substring(12, 13)) && isNaN(cv.substring(11, 12)) && cv.length >= 12) ||
            'Последнее значение должно быть одним из М, Ж или Т',
        v => v && v.some(cv => !!cv && cv.length === 13) || 'Код состоит из тринадцати символов'
      ]
    }
  },
  computed: {
    items () {
      return this.entries
    },
    getIcon () {
      if (Array.isArray(this.model)) {
        return ''
      } else {
        let icon = 'mdi-account'
        if (this.model) {
          switch (this.model.toUpperCase().slice(-1)) {
            case 'М':
              icon = 'mdi-account'
              break;
            case 'Ж':
              icon = 'mdi-face-woman'
              break;
            case 'Т':
              icon = 'mdi-gender-transgender'
              break;
            default:
              icon = 'mdi-account'
          }
        }
        return icon
      }
    }

  },
  watch: {
    search (val) {
      // Items have already been loaded
      // if (this.items.length > 0) return
      if (val === null || val.length < 2) {
        this.isLoading = false
        return
      }
      // Items have already been requested
      if (this.isLoading) return
      this.isLoading = true
      // Lazily load input items

      const requestOptions = {
        method: 'GET',
        headers: authHeader(),
        params: {
          code: val
        }
      }
      axios.get(this.$store.state.tableData.backend + '/api/customers/search', requestOptions)
          .then(res => {
            // this.entries =  res.data.map(v => ({'full_code': v.full_code}) )
            this.entries = res.data
            this.isLoading = false
          })
          .catch(err => {
          })
          .finally(() => (this.isLoading = false))
    },
    model (val, oldValue ) {
      this.$emit('update:value', val)
      //console.log('combo',val,oldValue)
      this.$emit('updateSelectedCustomer',oldValue)
      let fentry = this.entries.filter(v => v['full_code'] === val)
      let vm= this
      if (fentry.length > 0) {
        this.$emit('update:customerGroups', fentry[0].customerGroups)
        this.$emit('update:isTreatment', fentry[0].is_treatment)
        this.$emit('update:education', fentry[0].education)
        this.$emit('update:prevTestsResult', fentry[0].prev_tests_result)
      } else {
        let groups = this.$store.state.newOutreachReports.project === 1 ? [
              {
                "id": 1,
                "name": "ЛУН",
                "deleted": false
              }
            ] :
            [
              {
                "id": 2,
                "name": "СР",
                "deleted": false
              }
            ]
        this.$emit('update:customerGroups', groups)
      }

      axios.post(  `${API_URL}/api/customers/check_customers`,
          {'customer':val},
          {headers: authHeader()}
        ).then(res => {
              if (res.data) {
                vm.oldValue = res.data[val]
              }
            }
        )
    }
  },
  methods: {
    setSelection (event) {
      this.model=event.currentTarget['value'].toUpperCase()
      this.search=event.currentTarget['value'].toUpperCase()
    },
    updateCheckbox () {
      let dict = {}
      dict[this.model]=this.oldValue
      this.$emit('update:toRename', dict)
    },
    addCustomer () {
      this.$emit('addCustomer')
    },
    findGroup (code) {
      let fentry = this.entries.filter(v => v['full_code'] === code)
      return fentry.map(v => v.customerGroups.map(c => c.name)).flat()
    },
    isValidDate (s) {
      // var bits = s.split('-');
      var d = new Date(s.substring(2, 4) + '/' + s.substring(0, 2) + '/' + s.substring(4))
      return !!(d && (d.getMonth() + 1) == s.substring(2, 4) && d.getDate() == Number(s.substring(0, 2)))
    },
    clearInput (val) {
      this.model = ''
      this.$emit('clear')
    }
  }

}
</script>

<style lang="scss" scoped>

/deep/ .capitalised-input {
  text-transform: uppercase;
}

.v-icon.v-icon.v-icon--link {
  cursor: pointer;
  outline: none;
}

.v-application .primary--text {
  color: #1976d2 !important;
  caret-color: #1976d2 !important;
}

  .s-container, .s-results{
    position: relative;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: max-content;
  }
  .s-container{
    margin: 10px 40px;
    grid-gap: 5px;
  }
  .s-input-wrapper > input{
    height: 50px;
    width: 100%;
    background-color: #efefef;
    font-size: 1.5rem;
    padding: 2px 5px;
  }

  .s-result-items > div, .placeholder-item, .s-status-message{
    font-size: 1rem;

    padding: 4px 5px;
    min-height: 30px;
    display: flex;
    justify-content: space-between;
  }
  .s-result-items > div:nth-child(n+2){
    border-top: 2px solid #d8d8d8;
  }
  .category{
    font-style: italic;
    font-size: medium;
    font-weight: 600
  }

  .placeholder-item > div {
    position: relative;
    width:100%;
    height: 22px;
    padding: 5px;
    border-radius: 4px;

    background-size:900%;
    background-position: 100% 0%;
    animation: placeholder-animation 1s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
  }

  .s-status-message > p{
    width: 100%;
    text-align: center;
  }

  @keyframes placeholder-animation {
    0% {
    background-position: 100% 0%;
    }
    50% {
    background-position: 50% 0%;
    }
    100% {
    background-position: 0% 0%;
    }
  }

  .checkbox-label {
    -webkit-transform: translateY(-18px) scale(.75);
                  transform: translateY(-18px) scale(.75);
                  overflow: visible;
  }
</style>



// WEBPACK FOOTER //
// src/components/base/CustomersComboBox.vue